var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48561 0.136719H36.5169C38.3288 0.136719 39.8619 1.62629 39.8619 3.38671V22.6159C39.8619 24.3763 38.3288 25.8659 36.5169 25.8659H3.48561C1.67376 25.8659 0.140625 24.3763 0.140625 22.6159V3.38671C0.140625 1.62629 1.67376 0.136719 3.48561 0.136719Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1369 6.29688H15.7158V19.8442H24.1369V6.29688Z",
    fill: "#111111",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7004 13.0055C16.7004 10.4055 17.9636 7.94235 20.0688 6.30024C16.4197 3.5634 11.2267 3.97392 8.13903 7.25813C5.05131 10.5423 5.05131 15.6055 8.13903 18.8897C11.2267 22.1739 16.4197 22.5844 20.0688 19.8476C17.8232 18.0687 16.7004 15.6055 16.7004 13.0055Z",
    fill: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4011 18.344V18.0703H33.5414H33.2607H33.4011V18.344ZM33.9625 18.344V18.0703H33.8222L33.6818 18.344L33.5414 18.0703H33.4011V18.344V18.0703L33.5414 18.344L33.6818 18.0703L33.9625 18.344Z",
    fill: "#CBCBCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2458 13.0011C34.2458 16.2853 32.2809 19.2958 29.3335 20.8011C26.2458 22.3064 22.737 21.8958 20.0703 19.8432C23.8598 16.9695 24.5615 11.4958 21.6142 7.80111C21.1931 7.25375 20.6317 6.70639 20.0703 6.29586C22.737 4.24323 26.3861 3.83269 29.3335 5.33795C32.2809 6.70637 34.2458 9.71691 34.2458 13.0011Z",
    fill: "#CBCBCB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5157 26H3.48433C1.5331 26 0 24.5104 0 22.6146V3.38541C0 1.48958 1.5331 0 3.48433 0H36.5157C38.4669 0 40 1.48958 40 3.38541V22.6146C40 24.5104 38.4669 26 36.5157 26ZM3.48433 0.27085C1.67248 0.27085 0.278678 1.625 0.278678 3.38541V22.6146C0.278678 24.375 1.67248 25.7292 3.48433 25.7292H36.5157C38.3275 25.7292 39.7213 24.375 39.7213 22.6146V3.38541C39.7213 1.625 38.3275 0.27085 36.5157 0.27085H3.48433Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutVisa);
export default __webpack_public_path__ + "static/media/checkout-visa.7b2f62d49c22c5760bdcb48e10bb742c.svg";
export { ForwardRef as ReactComponent };